import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import { useEffect, useState } from 'react';
import { Spin } from 'antd';

export function ProtectedRoute() {
  const { isAuthenticated, checkSession } = useAuthStore();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Check if there's an existing session on mount
    checkSession().finally(() => setChecking(false));
  }, [checkSession]);

  if (checking) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Spin size="large" description="Loading..." />
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
